export default "__VITE_ASSET__CQcaLer7__"